"use strict";
/**
 * Created on 10 25 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ObjectUtils_1 = require("../../core/utils/ObjectUtils");
/**
 * General representation of key encapsulating id of {@link WindowItem window item} and id of {@link Product product}.
 * <br/>
 * You can use this tuple as a key of immutable map or as a value of immutable set.
 * @author JMe
 */


var WindowItemProductKey =
/*#__PURE__*/
function () {
  /**
   * Ctor.
   *
   * @param windowItemId identification of the windowItem
   * @param productId identification of a product
   */
  function WindowItemProductKey(windowItemId, productId) {
    _classCallCheck(this, WindowItemProductKey);

    this.windowItemId = windowItemId;
    this.productId = productId;
  }

  _createClass(WindowItemProductKey, [{
    key: "equals",
    value: function equals(other) {
      if (other instanceof WindowItemProductKey) {
        var otherKey = other;
        return this.windowItemId === otherKey.windowItemId && this.productId === otherKey.productId;
      } else {
        return false;
      }
    }
  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode("".concat(this.windowItemId, "_").concat(this.productId));
    }
  }]);

  return WindowItemProductKey;
}();

exports.WindowItemProductKey = WindowItemProductKey;